export default __webpack_public_path__ + "static/media/pixellab--web-design--05a--1200x900.cd722a35.jpg";